import React, { useEffect } from "react";
import {useNotificationsContext} from "../../context/NotificationsContext";
import Notification from "./Notification";
import "./style.scss";

const Notifications = ({classNameContainer, isPlayer = false}) => {
    const {messages, handleMessage, onCloseMessage, setIsShowPlayer} = useNotificationsContext();
    const className = 'notifications';

    useEffect(() => {
        if (!isPlayer) {
            return;
        }

        setIsShowPlayer(true);

        return () => {
            setIsShowPlayer(false);
        }
    }, [isPlayer]);

    return (
        <div className={`${classNameContainer ? classNameContainer : className} scrollable`}>
            {messages?.map(message => (
                <Notification
                    key={message.id}
                    message={message}
                    handleMessage={handleMessage}
                    onCloseMessage={onCloseMessage}
                />
            ))}
        </div>
    );
}

export default React.memo(Notifications);
